import { Link } from "react-router";

import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";

import {
  ratingStars,
  type StudioFilmRating,
} from "../echoflicks/studioRatings";

/**
 * "Agent ratings" for one agency (plan 2026-10-10): the latest films its agents
 * rated on real-estate.echoflicks.com, with the score, what they said (the reasons
 * they ticked and their note) and who rated it. Each row opens the film's session.
 */
export const AgentRatingsTable = ({
  ratings,
}: {
  ratings: readonly StudioFilmRating[];
}) => (
  <div className="mt-4">
    <h4 className="mb-1 text-sm font-medium">Latest agent ratings</h4>
    {ratings.length === 0 ? (
      <p className="text-xs text-muted-foreground">
        No film rated yet. Agents rate a film under it on the film page, or on
        the card that asks about their last film when they come back.
      </p>
    ) : (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Film</TableHead>
            <TableHead>Rating</TableHead>
            <TableHead>What they said</TableHead>
            <TableHead>By</TableHead>
            <TableHead>When</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ratings.map((row) => (
            <TableRow key={row.sessionId}>
              <TableCell className="text-xs">
                <Link
                  to={`/echoflicks_video_sessions/${encodeURIComponent(row.sessionId)}/show`}
                  className="underline-offset-2 hover:underline"
                >
                  {row.title}
                </Link>
              </TableCell>
              <TableCell className="whitespace-nowrap text-xs">
                <span aria-hidden className="mr-1 text-amber-500">
                  {ratingStars(row.rating)}
                </span>
                <span>{row.rating}/5</span>
              </TableCell>
              <TableCell className="max-w-md text-xs text-muted-foreground">
                {row.feedbackText ?? "—"}
              </TableCell>
              <TableCell className="text-xs">
                {row.creator.label}
                {row.creator.isStaff ? (
                  <Badge variant="secondary" className="ml-1 text-xs">
                    Staff
                  </Badge>
                ) : null}
              </TableCell>
              <TableCell className="whitespace-nowrap text-xs text-muted-foreground">
                {row.feedbackAt
                  ? new Date(row.feedbackAt).toLocaleDateString()
                  : "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )}
  </div>
);
